/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PingService {

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static getApiPingNumbersTest(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ping/NumbersTest',
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static getApiPing(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ping',
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static getApiPingHubPing(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ping/hubPing',
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static getApiPingClioPing(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ping/clioPing',
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static getApiPingHangPing(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ping/hangPing',
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static getApiPingZoomPing(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ping/zoomPing',
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static postApiPingNotification(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Ping/notification',
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public static getApiPingHubspotDocs(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ping/hubspot/docs',
        });
    }

    /**
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public static postApiPingHubspotMatterDocs(
requestBody?: Array<string>,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Ping/hubspot/matter/docs',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

}
